import { Box} from "@mui/material";
import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../core/context/ToolContext";
import { BackDrop } from "../../../../core/global/BackDrop";
import { ConfirmationWarning } from "../../../../core/global/modal/Confirmation";
import { SubmitReconcile, ReconciledSalesRead, DeclineReconcile } from "../../global/API";
import { useHistory } from "react-router-dom";
import { FormFooter } from "./FormFooter";
import { FormHeader } from "./FormHeader";
import { FormBody } from "./FormBody";

export const Form = () => {
    const {reconciliation_state, session_state, tool_state} = useContext(ToolContext)
    const {reconData, submitFormLoader, isToReconcile, loader, toReconcile, date, declineFormLoader} = reconciliation_state
    const {__SESSION} = tool_state
    const {sessionData, navSession} = session_state
    const user_id = parseInt(atob(__SESSION.data.ainfo.aid).split('_', 2)[1]);
    const nav = useHistory()
    const role = __SESSION.data.uaccess[0].role_name


    const handleBackClick = ()=>{nav.push("/reconciliation")}

    const handleChange = (e) => {
        const { name, value } = e.target;
        const remarksRegex = /^[a-zA-Z0-9\s.,!?'"()-]*$/;
        const cashRegex = /^(?:\d+|\d+\.\d{0,2})$/;

        if (name === "remarks") {
            if (!remarksRegex.test(value)) return;
            reconData.set((prev) => ({ ...prev, [name]: value }));
            return;
        }

        if (name === "actualCash" || name === "reconciledSales") {
            if (value === "") {
                reconData.set((prev) => ({ ...prev, [name]: 0 }));
                return;
            }
            if (!cashRegex.test(value)) return;
            let sanitized = value;
            if (/^0+\d/.test(value)) {
                sanitized = value.replace(/^0+/, "");
            }
            reconData.set((prev) => ({ ...prev, [name]: sanitized }));
            return;
        }

        reconData.set((prev) => ({ ...prev, [name]: value }));
    };


    const branchEodSalesRead = async() =>{
        const qsp = {
            branch_sales_id: toReconcile.data.branch_sales_id,
            company_branch_id: sessionData.data.branch_id,
            date: date.data 
        }
        try {
            navSession.set((prev) => ({...prev, isShow:true}))
            const res = await ReconciledSalesRead(qsp);
            if (res.bs_data && res.bs_data.length > 0) {
                reconData.set(prev => ({
                    ...prev,
                    status: res.bs_data[0].status,
                    remarks: res.bs_data[0].remarks || "",
                    reconciledRemarks: res.bs_data[0].reconciled_remarks || "",
                    actualCash: isToReconcile.data ? res.bs_data[0].sales : res.bs_data[0].actual_cash || 0,
                    id: res.bs_data[0].branch_sales_id,
                    totalSales: res.total_sales[0].total_amount || 0,
                    date: res.bs_data[0].date,
                    variance: res.bs_data[0].variance || 0
                }));
            }
            loader.set(prev => ({ ...prev, isShowData: true}));
            navSession.set((prev) => ({...prev, isShow:false}))
        } catch (error) {
            console.error("Failed to fetch transfers:", error)
        }
    }

    const submitHandler = async(type) => {
        if (type === 'cancel') {
            submitFormLoader.set(prev => ({...prev, modal:false}));
        } 
        else{

            let body = {
                branch_sales_id: parseInt(reconData.data.id),
                total_sales: parseFloat(reconData.data.totalSales),
                reconciled_sales: parseFloat(reconData.data.reconciledSales),
                user_id: parseInt(user_id),
                date: reconData.data.date,
                actual_cash: parseFloat(reconData.data.actualCash),
                variance: parseFloat(
                    (parseFloat(reconData.data.actualCash) - parseFloat(reconData.data.totalSales)).toFixed(2)
                ),
                remarks: reconData.data.reconciledRemarks || "",
                // status: parseInt(reconData.data.status) + 1
            };
            submitFormLoader.set(prev => ({...prev, submitted: false, modal: false}));
            try {
                let res = await SubmitReconcile(body);
                if (res.msg === 'success') {
                    submitFormLoader.set(prev => ({...prev, loader: false, submitted: true}));
                    nav.push('/reconciliation');
                } 
            } catch (error) {
                console.error('Submission failed:', error);
            }
        }
            submitFormLoader.set(prev => ({...prev, loader: false, modal: false}));
    }

    const handleSubmit = () =>{submitFormLoader.set(prev => ({...prev, modal:true, loader: false}))}
    const handleDecline = () =>{declineFormLoader.set(prev => ({...prev, modal:true, loader: false}))}

    const declineHandler = async(type) => {
        if (type === 'cancel'){
            declineFormLoader.set(prev => ({...prev, modal:false}))
        } 
        else{
            let body = {
                id: parseInt(reconData.data.id),
                user_id: parseInt(user_id),
            };
            declineFormLoader.set(prev => ({...prev, submitted: false, modal: false}));
            try {
                let res = await DeclineReconcile(body);
                if (res.msg === 'success') {
                    declineFormLoader.set(prev => ({...prev, loader: false,  submitted: true}));
                    nav.push('/reconciliation');
                } 
            } catch (error) {
                console.error('Submission failed:', error);
            }
        }
            declineFormLoader.set(prev => ({...prev, loader: false, modal: false}));
        }

    useEffect(() => {
        role !== "Regular User" && isToReconcile.set(false)
        !toReconcile.data.branch_sales_id && nav.push('/reconciliation') 
        branchEodSalesRead()
        // eslint-disable-next-line
    }, []);

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ maxWidth: 500, mx: "auto", mt: 6, p: 3}}>
            {!navSession.data.isShow &&
                <Box>
                    <FormHeader handleBackClick={handleBackClick}/>
                    <Box p={2} bgcolor="#FFFFFF" boxShadow={2} borderRadius={2} fontSize={13}> 
                        <FormBody handleChange={handleChange}/>
                        <FormFooter handleChange={handleChange} handleSubmit={handleSubmit} handleDecline={handleDecline} role={role}/>
                    </Box>
                </Box>
            }
            
            <BackDrop open={navSession.data.isShow} text={"Fetching Data..."}/>
            <BackDrop open={!submitFormLoader.data.submitted || !declineFormLoader.data.submitted} text={"Saving Data..."}/>
            <ConfirmationWarning submitFormLoader={submitFormLoader.data.modal || submitFormLoader.data.loader ? submitFormLoader.data : declineFormLoader.data} submitHandler={submitFormLoader.data.modal || submitFormLoader.data.loader ? submitHandler : declineHandler}/>
        </Box>
    );
}
